import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center border border-slate-200">
        <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-4"/>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Pagamento cancelado</h1>
        <p className="text-slate-500 mt-2">Você pode tentar novamente quando quiser.</p>
        <Button onClick={()=>navigate("/financeiro")} className="mt-6 bg-rose-600 hover:bg-rose-700">Voltar</Button>
      </Card>
    </div>
  );
}
